import { render } from "./Educators.vue?vue&type=template&id=4e173f78&scoped=true"
import script from "./Educators.vue?vue&type=script&lang=js"
export * from "./Educators.vue?vue&type=script&lang=js"

import "./Educators.vue?vue&type=style&index=0&id=4e173f78&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e173f78"]])

export default __exports__